  import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error", error, errorInfo);
    
    // Auto-reload on chunk load errors (cache issues after deployment)
    const isChunkLoadError = 
      error?.message?.includes("Failed to fetch dynamically imported module") || 
      error?.message?.includes("Importing a module script failed");
      
    if (isChunkLoadError) {
      const hasReloaded = sessionStorage.getItem('chunk_error_reloaded');
      if (!hasReloaded) {
        sessionStorage.setItem('chunk_error_reloaded', 'true');
        window.location.reload();
        return;
      }
    }

    this.setState({ errorInfo });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    sessionStorage.removeItem('chunk_error_reloaded');
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#121212',
          color: '#ffffff',
          fontFamily: 'Inter, sans-serif',
          textAlign: 'center',
          padding: '20px'
        }}>
          <h1 style={{ color: '#ff4d4f', marginBottom: '10px' }}>Something went wrong.</h1>
          <p style={{ color: '#a0a0a0', marginBottom: '20px', maxWidth: '600px' }}>
            We're sorry, but an unexpected error occurred while loading this page.
          </p>
          <button 
            onClick={this.handleRetry}
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600',
              transition: 'background-color 0.3s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
          >
            Retry / Reload Page
          </button>
          
          {import.meta.env.DEV && (
             <details style={{ whiteSpace: 'pre-wrap', marginTop: '30px', textAlign: 'left', background: '#1e1e1e', padding: '15px', borderRadius: '8px', maxWidth: '80vw', overflow: 'auto' }}>
               <summary style={{ cursor: 'pointer', color: '#ffb86c' }}>Error Details</summary>
               <br />
               {this.state.error && this.state.error.toString()}
               <br />
               {this.state.errorInfo && this.state.errorInfo.componentStack}
             </details>
          )}
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
